import { observer } from 'mobx-react-lite'
import { useTheme } from 'theme/useTheme'
import { ulid } from 'ulid'
import { SxProps, Theme } from '@mui/material/styles'
import Skeleton, { SkeletonProps } from '@mui/material/Skeleton'

export default observer(function SkeletonLoadingBox({ length, isLoading, children, sx }: { length?: number, isLoading?: boolean, children?: React.ReactNode, sx?: SxProps<Theme> }) {
   const theme = useTheme()

   if (typeof isLoading === 'boolean' && isLoading === false) {
      return children
   }

   const baseSxProps: SkeletonProps['sx'] = {
      background: theme.palette.grey[300],
      ...sx
   }

   if (!length || length === 1) {
      return <Skeleton
         animation={false}
         variant="rounded"
         sx={baseSxProps}
      />
   }

   return Array.from({ length }).map((_, rowIndex) => {
      return <Skeleton
         key={`skeleton-grid-row-${ulid()}`}
         animation={false}
         variant="rounded"
         sx={{ mt: rowIndex === 0 ? 0 : '-20px', ...baseSxProps }}
      />
   })
})
